import { render, staticRenderFns } from "./OperationLog.vue?vue&type=template&id=2c96b082&scoped=true"
import script from "./OperationLog.vue?vue&type=script&lang=js"
export * from "./OperationLog.vue?vue&type=script&lang=js"
import style0 from "./OperationLog.vue?vue&type=style&index=0&id=2c96b082&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c96b082",
  null
  
)

export default component.exports